import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IQuestion } from "../shared/models/interfaces/question";
import { Observable } from 'rxjs';
import { Urls } from "../shared/Urls";
import { map } from 'rxjs/operators';
import { Question } from "../shared/models/question.model";
import { IQuestionType } from "../shared/models/interfaces/question-type";
import { OperatorHelpers } from '../shared/helpers/operator.helpers';

@Injectable({
  providedIn: 'root'
})
export class QuestionsService {

  constructor(private http: HttpClient) {}

  getQuestionById(questionId: number): Observable<IQuestion | null> {
    return this.http.get(`${Urls.getQuestionById}${questionId}`)
      .pipe(
        map(responseData => {
          if (responseData) {
            return responseData as IQuestion;
          }

          return null;
        })
      );
  }

  create(question: IQuestion): Observable<IQuestion> {
    return this.http.post(Urls.createQuestion, question)
      .pipe(
        map((responseData) => {
          return responseData as IQuestion;
        })
      );
  }

  update(question: IQuestion): Observable<IQuestion> {
    return this.http.put(Urls.updateQuestion, question)
      .pipe(
        map((responseData) => {
          return responseData as IQuestion;
        })
      );
  }

  deleteReferralForm(questionId: number): Observable<any> {
    return this.http.delete(`${Urls.deleteQuestion}?id=${questionId}`);
  }

  getQuestionTypes(): Observable<IQuestionType[]> {
    return this.http
      .get(`${Urls.getQuestionTypes}`)
      .pipe(
        map(responseData => {
          const data: IQuestionType[] = [];
          return OperatorHelpers.mapToList(responseData, data);
        })
      );
  }
}
